<template lang="pug">
  Modal.analyzeModal(v-model='analyzeModal' closable footer-hide :styles="{width:'840px',height:'607px'}")
    h1(slot='header') 案例分析
    div.main
      .context(v-html='context')
</template>

<script>
export default {
  name: "analyzeModal",
  data() {
    return {
      analyzeModal: false,
      context: "",
      baseImg: ""
    };
  },
  created() {
    const id = JSON.parse(sessionStorage.getItem("vuex")).doCase.caseId;
    this.$http.getCaseExperimentById({ id }).then(res => {
      console.log("res", res);
      if (res.data.success) {
        if (res.data.data.editorOption) {
          this.context = res.data.data.editorOption;
          // eslint-disable-next-line no-useless-escape
          /* const reg = /(<p\s\S+>)[a-zA-Z\d]+(<\/p>)/g;
          console.log("reg", reg.exec(this.context)); */
        }
      }
    });
  }
};
</script>

<style lang="stylus">
.analyzeModal
  .ivu-modal-body
    padding 15px 0 0 15px
  .ivu-modal-close
    background rgba(200, 200, 200, 0.5)
  .ql-size-small
    font-size 0.75em
  .ql-size-large
    font-size 1.5em
  .ql-size-huge
    font-size 2.5em
</style>
